import { motion } from "framer-motion";
import Seo from "@/components/Seo";

export default function Home() {
  return (
    <motion.main
      className="flex-1 flex items-center justify-center px-6"
      data-testid="home-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
    >
      <Seo
        title="TRONA — Electronic Music Collective, Milano"
        siteName="TRONA"
        description="TRONA is an electronic music collective based in Milan. Built on heat."
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "MusicGroup",
          name: "TRONA",
          genre: "Electronic",
          email: "booking@tronamusic.com",
          location: { "@type": "Place", name: "Milan, Italy" },
        }}
      />
      <h1 className="m-0" data-testid="home-logo" aria-label="TRONA">
        <img
          src="/trona-logo.webp"
          alt="TRONA logo"
          className="w-[78vw] max-w-[640px] h-auto block"
        />
      </h1>
    </motion.main>
  );
}
